/**
 * 登录 / 注册。STATSIG.AUTH.LOGIN → AUTH_LOGIN
 *
 * 打开 /login 打 STATSIG.COMMON.VIEW，value=login。
 * 打开 /signup 打 STATSIG.COMMON.VIEW，value=signup。
 * 选套餐 / 付款见 STATSIG.PAYMENT（payment.ts）。
 * 登录成功打 LOGIN，渠道放 value / metadata.type：
 * password|google|apple|outlook|oauth|email_code
 * 登录失败打 LOGIN_FAIL（密码 / OAuth / 邮箱验证码），不含表单前端校验。
 */
export enum AuthEvent {
    /**
     * 登录成功。
     * value 与 metadata.type 相同：password|google|apple|outlook|oauth|email_code
     */
    LOGIN = 'AUTH_LOGIN',
    /**
     * 登录失败（业务错误、HTTP 非 200、网络异常、账号未找到）。
     * value 与 metadata.type 相同：password|google|apple|outlook|email_code
     * 属性 reason：account_not_found|error
     * 属性 error_text（截断至 200，可选）
     */
    LOGIN_FAIL = 'AUTH_LOGIN_FAIL',
    /** 注册成功。value 与 metadata.customer_id 相同：组织 customerid */
    SIGNUP = 'AUTH_SIGNUP',
    /** 切换组织。value 与 metadata.customer_id 相同：目标组织 customerid */
    ORG_CHANGE = 'AUTH_ORG_CHANGE',
}
